// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-page-fields-admin__container .modal2__content {
    padding: 24px;
}

.tournament-page-fields-admin__subtitle.baloa-table {
    color: var(--primary-very-dark-color);
    margin-bottom: 16px;
}

.tournament-page-fields-admin__fields {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.tournament-page-fields-admin__fields__create-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 12px;
}

.tournament-page-fields-admin__fields__create-action .baloa-hyperlink-2 {
    color: var(--primary-very-dark-color);
}

.tournament-page-fields-admin__fields__create-action .secondary-button {
    padding: 10px 12px;
    display: flex;
    gap: 4px;
}

.tournament-page-fields-admin__fields__create-action .secondary-button .hubicon-add_option {
    font-size: 18px;
}

.tournament-page-fields-admin__container .modal2__container {
    width: 580px;
}

.tournament-page-fields-admin__fields__list-container {
    border-top: 1px solid var(--new-gray-background-color);
    max-height: 500px;
    overflow-y: scroll;
}

.tournament-page-fields-admin__fields__list__empty {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: center;
    padding: 44px 0;
}

.tournament-page-fields-admin__fields__list__empty .baloa-table-column:first-of-type {
    color: var(--basic-gray-color);
}

.tournament-page-fields-admin__fields__list__empty .baloa-table-column:last-of-type {
    color: var(--new-green-color);
    cursor: pointer;
}

.tournament-page-fields-admin__fields__list {
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.tournament-page-fields-admin__fields__field {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 6px;
    padding: 10px;    
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tournament-page-fields-admin__fields__field .baloa-table-column {
    color: var(--primary-very-dark-color);
}

.tournament-page-fields-admin__fields__field .baloa-username {
    color: var(--primary-dark-color);
}

.tournament-page-fields-admin__fields__field-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tournament-page-fields-admin__fields__field-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.tournament-page-fields-admin__fields__field-actions span {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-page-fields-admin-modal/TournamentPageFieldsAdminModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sDAAsD;IACtD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".tournament-page-fields-admin__container .modal2__content {\n    padding: 24px;\n}\n\n.tournament-page-fields-admin__subtitle.baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 16px;\n}\n\n.tournament-page-fields-admin__fields {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.tournament-page-fields-admin__fields__create-action {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 8px 12px;\n}\n\n.tournament-page-fields-admin__fields__create-action .baloa-hyperlink-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-page-fields-admin__fields__create-action .secondary-button {\n    padding: 10px 12px;\n    display: flex;\n    gap: 4px;\n}\n\n.tournament-page-fields-admin__fields__create-action .secondary-button .hubicon-add_option {\n    font-size: 18px;\n}\n\n.tournament-page-fields-admin__container .modal2__container {\n    width: 580px;\n}\n\n.tournament-page-fields-admin__fields__list-container {\n    border-top: 1px solid var(--new-gray-background-color);\n    max-height: 500px;\n    overflow-y: scroll;\n}\n\n.tournament-page-fields-admin__fields__list__empty {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n    padding: 44px 0;\n}\n\n.tournament-page-fields-admin__fields__list__empty .baloa-table-column:first-of-type {\n    color: var(--basic-gray-color);\n}\n\n.tournament-page-fields-admin__fields__list__empty .baloa-table-column:last-of-type {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.tournament-page-fields-admin__fields__list {\n    padding: 10px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.tournament-page-fields-admin__fields__field {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 6px;\n    padding: 10px;    \n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.tournament-page-fields-admin__fields__field .baloa-table-column {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-page-fields-admin__fields__field .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.tournament-page-fields-admin__fields__field-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.tournament-page-fields-admin__fields__field-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.tournament-page-fields-admin__fields__field-actions span {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
